// usePollingLivestreamFundingDetail.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import fetchLivestreamFundingDetail from '../action/fetchLivestreamFundingDetail.js';

/**
 * Hook to poll livestream funding detail data.
 * @param {object} options - hook options.
 * @param {string} [options.streamId = ''] - stream id.
 * @param {string} [options.runningShowId = ''] - running show id.
 * @param {number} [options.intervalSeconds = 5] - interval seconds.
 * @param {boolean} [options.canFetchData = false] - whether to fetch data.
 */
const usePollingLivestreamFundingDetail = ({
  streamId = '',
  runningShowId = '',
  intervalSeconds = 5,
  canFetchData = false,
} = {}) => {
  const dispatch = useDispatch();

  // fetch livestream funding detail interval.
  useEffect(() => {
    let timer;

    if (canFetchData) {
      dispatch(fetchLivestreamFundingDetail({ streamId, runningShowId }));
      timer = setInterval(() => {
        dispatch(fetchLivestreamFundingDetail({ streamId, runningShowId }));
      }, intervalSeconds * 1000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [canFetchData, dispatch, intervalSeconds, runningShowId, streamId]);
};

export default usePollingLivestreamFundingDetail;
